import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Chip } from '@mui/material'
import { ErrorOutline, Info } from '@mui/icons-material'

import {
  TableContainerStyled,
  TableStyled,
  TableHeadStyled,
  TableRowStyled,
  TableCellStyled,
  TableBodyStyled,
  TableFooter,
  Button,
  Row
} from 'components'
import {
  LogItem,
  IGetAllPaginatedResponse,
  IGetAllPaginatedParams
} from 'services/NGT/Log'
import { useGet } from 'hooks'
import { FUNCTIONS, FORMAT, SPACING } from 'utils'

const Table: React.FC = () => {
  const { getValues, handleSubmit, reset } =
    useFormContext<IGetAllPaginatedParams>()
  const { data, tableFooterControl, refresh } = useGet<
    IGetAllPaginatedParams,
    IGetAllPaginatedResponse
  >({
    api: 'Read',
    isPaginated: true,
    params: {
      ...(FUNCTIONS.filterObject(
        {
          ...getValues(),
          dtInicio: FUNCTIONS.turnOffHourMinuteSecond(getValues('dtInicio')),
          dtFim: FUNCTIONS.turnOffHourMinuteSecond(getValues('dtFim'))
        },
        Boolean
      ) as IGetAllPaginatedParams)
    },
    url: 'Log/GetAllPaginated'
  })

  const refreshData = (): void => {
    refresh({
      ...(FUNCTIONS.filterObject(
        {
          ...getValues(),
          dtInicio: FUNCTIONS.turnOffHourMinuteSecond(getValues('dtInicio')),
          dtFim: FUNCTIONS.turnOffHourMinuteSecond(getValues('dtFim'))
        },
        Boolean
      ) as IGetAllPaginatedParams),
      pageNumber: 1
    })
  }

  const onSubmitForm = (): void => {
    refreshData()
  }

  const handleResetForm = (): void => {
    reset()
    refreshData()
  }

  return (
    <>
      <Row justifyContent="flex-end">
        <Button
          text="Limpar"
          variantButton="outlined"
          marginRight={SPACING.spacing10}
          onClick={handleResetForm}
        />
        <Button
          text="Pesquisar"
          variantButton="default"
          onClick={handleSubmit(onSubmitForm)}
        />
      </Row>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left">Mensagem</TableCellStyled>
              <TableCellStyled align="left">Usuário</TableCellStyled>
              <TableCellStyled align="left">API</TableCellStyled>
              <TableCellStyled align="left">Data</TableCellStyled>
              <TableCellStyled align="left">Nível Log</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {data?.items?.map((logItem: LogItem) => (
              <TableRowStyled key={logItem.id}>
                <TableCellStyled align="left">
                  {logItem.txMensagem}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {logItem.txUsuario}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {logItem.txNmApiLogada}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {FORMAT.formatDDMMYYYY(logItem.dtInformacaoLogada)}
                </TableCellStyled>
                <TableCellStyled align="left">
                  <Chip
                    label={logItem.txNivelLog}
                    color={logItem.txNivelLog === 'Error' ? 'error' : 'info'}
                    icon={
                      logItem.txNivelLog === 'Error' ? (
                        <ErrorOutline />
                      ) : (
                        <Info />
                      )
                    }
                    size="small"
                  />
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        rows={data?.items}
        totalItems={data?.pageCount}
        {...tableFooterControl}
      />
    </>
  )
}

export default Table
